export default "__VITE_ASSET__CT5tb6ji__"